exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[disabled][data-v-eda5465e]{\n  background-color: #e0e0ff;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput[data-v-eda5465e]::-webkit-outer-spin-button,\ninput[data-v-eda5465e]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-eda5465e] {\n  -moz-appearance: textfield;\n}\n.pdf-tab input[data-v-eda5465e]{\n  border: none;\n}\ntd[data-v-eda5465e]{\n  color: black;\n}\n", ""]);

// exports
